import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/Button';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';
import { intlMessage } from 'constants/propTypes';
import { selectIsMobile } from 'selectors/ui';

import { useSmartRateFaqsQuery } from './SmartRate.hooks';
import { isSmartRateFaqPublished, navigateToSmartRateFaq } from './SmartRateFaqs.helpers';

const SmartRateFaqLinkMessage = ({ as, className, faqId, linkClassName, message, messageWithoutLink }) => {
  const dispatch = useDispatch();
  const isMobile = useSelector(selectIsMobile);
  const { data: faqs = [] } = useSmartRateFaqsQuery();
  const hasFaq = isSmartRateFaqPublished(faqs, faqId);

  const handleFaqLinkClick = () =>
    navigateToSmartRateFaq(faqId, {
      beforeScroll: isMobile ? () => dispatch(closeModal()) : undefined,
    });

  const renderFaqLink = text =>
    linkClassName ? (
      <button className={linkClassName} onClick={handleFaqLinkClick} type="button">
        {text}
      </button>
    ) : (
      <Button styled="inline-link" onClick={handleFaqLinkClick} type="button">
        {text}
      </Button>
    );

  return (
    <Message
      as={as}
      className={className}
      message={hasFaq ? message : messageWithoutLink}
      values={hasFaq ? { faqLink: renderFaqLink } : undefined}
    />
  );
};

SmartRateFaqLinkMessage.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  faqId: PropTypes.string.isRequired,
  linkClassName: PropTypes.string,
  message: intlMessage.isRequired,
  messageWithoutLink: intlMessage.isRequired,
};

export default SmartRateFaqLinkMessage;
